<template>
  <div>
    <v-dialog :value="isModalOpen" persistent scrollable transition="scroll-y-transition">
      <v-card>
        <v-card-title class="headline">{{ title }}</v-card-title>

        <v-card-text v-if="!isPlaceNotFound">
          <template v-if="showTabs">
            <v-tabs>
              <v-tabs-slider></v-tabs-slider>

              <v-tab v-for="tab in tabs" :key="tab.id" :href="`#tab-${tab.id}`">
                {{ tab.title }}
              </v-tab>

              <v-tab-item value="tab-info">
                <div class="mt-3">
                  <place-info
                    :contacts="contacts"
                    :address="place.address"
                    :options="place.options"
                    :lat="coordinate.lat"
                    :lon="coordinate.lon"
                  />
                </div>
              </v-tab-item>

              <v-tab-item value="tab-beer">
                Пиво
              </v-tab-item>
            </v-tabs>
          </template>

          <template v-else>
            <place-info
              :contacts="contacts"
              :address="place.address"
              :options="place.options"
              :lat="coordinate.lat"
              :lon="coordinate.lon"
            />
          </template>
        </v-card-text>

        <v-btn color="green darken-1" class="mx-3 my-3" text :to="{ name: 'main' }">
          Закрыть
        </v-btn>
      </v-card>
    </v-dialog>

    <loader v-if="!isModalOpen" />
  </div>
</template>

<script>
import PlaceService from '@/services/PlaceService';
import Loader from '@/components/Loader';
import PlaceInfo from '@/components/place/PlaceInfo';

export default {
  name: 'PlaceView',

  components: { PlaceInfo, Loader },

  data() {
    return {
      isModalOpen: false,
      isPlaceNotFound: false,
      place: {},
      contacts: {},
      coordinate: {
        lat: 0,
        lon: 0,
      },
    };
  },

  computed: {
    title() {
      return this.isPlaceNotFound ? 'Not found' : this.place.name;
    },

    showTabs() {
      return this.tabs.length > 1;
    },

    tabs() {
      return [
        {
          id: 'info',
          title: 'Информация',
        },
      ];
    },
  },
  mounted() {
    this.loadPlace();
  },
  methods: {
    loadPlace() {
      this.isPlaceNotFound = false;
      this.isModalOpen = false;

      PlaceService.findById(this.$route.params.id)
        .then((response) => {
          this.place = response;
          this.coordinate = response.coordinate;

          this.$store.dispatch('map/setCenter', {
            lat: response.coordinate.lat,
            lng: response.coordinate.lon,
          });

          const contacts = {};
          (response.contacts || []).forEach((contact) => {
            contacts[contact.uid] = contact.value;
          });

          this.contacts = contacts;
        })
        .catch(() => {
          this.isPlaceNotFound = true;
        })
        .finally(() => {
          this.isModalOpen = true;
        });
    },
  },
};
</script>

<style scoped></style>
